import { IRoute, RoleTypes } from 'models';
import { AppRouteNameList } from '../AppRouteNameList';

const requiredRoles = [RoleTypes.admin];

export const PaymentRoute: IRoute = {
	name: AppRouteNameList.payment,
	requiredRoles,
};
